import { MemberRole } from '@/services/internal-api/accounts/types/accounts-api-service-enums';
import { MailPlus } from 'lucide-react';
import { useFieldArray, UseFormReturn } from 'react-hook-form';

import InvitationRow from './invitation-row';
import { type TeamMember, InviteFormValues } from '../types/team-types';

import { BUTTON_SIZE, BUTTON_VARIANT } from '@/components/ui/types/button-variants-enums';
import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';

interface InvitationFormProps {
  form: UseFormReturn<InviteFormValues>;
  onSubmit: (data: InviteFormValues) => void;
  currentUserRole: TeamMember['role'] | null;
  formId?: string;
  className?: string;
}

export default function InvitationForm({
  form,
  onSubmit,
  currentUserRole,
  formId = 'invite-member-form',
  className = 'space-y-4',
}: InvitationFormProps) {
  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: 'invitations',
  });

  return (
    <Form {...form}>
      <form
        id={formId}
        onSubmit={e => { void form.handleSubmit(onSubmit)(e); }}
        className={className}
      >
        <div className="space-y-3">
          {fields.map((field, index) => (
            <InvitationRow
              key={field.id}
              field={field}
              index={index}
              control={form.control}
              onRemove={remove}
              canRemove={fields.length > 1}
              currentUserRole={currentUserRole}
              showLabels={index === 0}
            />
          ))}
        </div>

        <Button
          type="button"
          variant={BUTTON_VARIANT.SECONDARY}
          size={BUTTON_SIZE.COMPACT}
          onClick={() => append({ email: '', role: MemberRole.MEMBER })}
          className="mt-3 w-full"
          disabled={fields.length >= 10}
        >
          <MailPlus />
          Add email {fields.length >= 10 ? '(10 max)' : null}
        </Button>

        {fields.length >= 10 ? (
          <p className="pt-2 text-sm text-content-secondary">
            Maximum 10 invitations can be sent at once.
          </p>
        ) : null}
      </form>
    </Form>
  );
}
